export const formatMiles = (value: string) => {
  const number = Number(value);
  // Si el valor no es un número válido, devolver "0" en lugar de "NaN"
  if (Number.isNaN(number)) return '0';
  return new Intl.NumberFormat('es-AR').format(number);
};
